import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGlobalContext } from "../ContextApi/GlobalContext";

const TITLE_MAP = [
  { test: (p) => p === "/dashboard", name: "Dashboard" },
  { test: (p) => p === "/forms", name: "My Forms" },
  { test: (p) => p === "/forms/create", name: "Create Form" },
  { test: (p) => p.startsWith("/forms/edit/"), name: "Edit Form" },
  {
    test: (p) => /^\/forms\/[^/]+$/.test(p) && p !== "/forms/create",
    name: "Form Details",
  },
  { test: (p) => p === "/queries", name: "Queries" },
  { test: (p) => p === "/notes", name: "Notes" },
  { test: (p) => p === "/myprofile", name: "My Profile" },
  { test: (p) => p === "/support", name: "Help & Support" },
  { test: (p) => p === "/plans", name: "Plans" },
];

/** Keep MobileAppBar title in sync with the current route (deep links included). */
export function useSyncPageTitle() {
  const location = useLocation();
  const { state, dispatch } = useGlobalContext();

  useEffect(() => {
    const match = TITLE_MAP.find((entry) => entry.test(location.pathname));
    const nextName = match?.name || "ContactHQ";
    const nextLink = location.pathname;

    if (state.pageName === nextName && state.pageLink === nextLink) return;

    dispatch({ pageName: nextName, pageLink: nextLink });
    // Only re-run on route change — dispatch is stable
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);
}
